


  
  

  var faD = {
    prefix: 'fasr',
    iconName: 'd',
    icon: [
      384,
      512,
      [100],
      '44',
      
      'M0 32l24 0 136 0c123.7 0 224 100.3 224 224s-100.3 224-224 224L24 480 0 480l0-24L0 56 0 32zM48 80l0 352 112 0c97.2 0 176-78.8 176-176s-78.8-176-176-176L48 80z'
      
    ]
  };

  

  
  

  var faX = {
    prefix: 'fasr',
    iconName: 'x',
    icon: [
      384,
      512,
      [120],
      '58',
      
      'M3 32L162.5 256 3 480 62 480 192 297.4 322 480l58.9 0L221.5 256 381 32 322 32 192 214.6 62 32 3 32z'
      
    ]
  };

  

  
  

  var faDollarSign = {
    prefix: 'fasr',
    iconName: 'dollar-sign',
    icon: [
      320,
      512,
      [61781,128178,"dollar","usd"],
      '24',
      
      'M184 24l0-24L136 0l0 24 0 47.7c-3.1 .1-6.2 .3-9.3 .6c-23.2 1.9-47.2 7.4-67.2 20.1C38.7 105.6 23.5 126 18 154.2c-3.9 20.3-2 38.8 6.1 55.2c8 16 20.9 27.6 34.8 36.2c26.2 16.2 61.9 25.3 92.9 33.2l2.3 .6c33.9 8.6 62.6 16.1 81.7 28c9 5.6 14.3 11.2 17.1 16.9c2.7 5.3 4.2 12.8 2 24.5c-2.9 14.7-13.4 26.9-34.5 34.9c-21.6 8.2-52 10.9-87.6 5.9c-22.6-3.3-61.8-12.7-83-22.1l-21.9-9.7L8.3 401.5l21.9 9.7C57 423.2 101.1 433.4 126 437l.1 0c3.3 .5 6.6 .9 9.9 1.2l0 49.7 0 24 48 0 0-24 0-48.6c19.3-1.3 37.4-4.9 53.5-11c31.9-12.1 57.7-35.2 64.5-70.6c3.9-20.3 2-38.8-6.1-55.2c-8-16-20.9-27.6-34.8-36.2c-26.2-16.2-61.9-25.3-92.9-33.2l-2.3-.6c-33.9-8.6-62.6-16.1-81.7-28c-9-5.6-14.3-11.2-17.1-16.9c-2.7-5.3-4.2-12.8-2-24.5c2.9-14.8 10.1-24 20.2-30.4c10.9-6.9 26.3-11.2 45.3-12.7c38.3-3.1 83.1 5.3 113.9 12.5l23.4 5.5 11-46.7L255.5 86c-18.7-4.4-44.2-9.7-71.5-12.5L184 24z'
      
    ]
  };

  
    var faDollar = faDollarSign;
  
    var faUsd = faDollarSign;
  

  
  

  var faM = {
    prefix: 'fasr',
    iconName: 'm',
    icon: [
      448,
      512,
      [109],
      '4d',
      
      'M0 32L0 56 0 456l0 24 48 0 0-24 0-319.9 156 237 20 30.5 20-30.5 156-237L400 456l0 24 48 0 0-24 0-400 0-24-36.9 0-7.1 10.8L224 316.3 44 42.8 36.9 32 0 32z'
      
    ]
  };

  

  
  

  var faCalendar = {
    prefix: 'fasr',
    iconName: 'calendar',
    icon: [
      448,
      512,
      [128197,128198],
      'f133',
      
      'M152 24l0-24L104 0l0 24 0 40L0 64l0 80 0 48L0 464l0 48 48 0 352 0 48 0 0-48 0-272 0-48 0-80L344 64l0-40 0-24L296 0l0 24 0 40L152 64l0-40zM48 192l352 0 0 272L48 464l0-272z'
      
    ]
  };

  

  
  

  var faT = {
    prefix: 'fasr',
    iconName: 't',
    icon: [
      384,
      512,
      [116],
      '54',
      
      'M24 32L0 32 0 80l24 0 144 0 0 376 0 24 48 0 0-24 0-376 144 0 24 0 0-48-24 0L192 32 24 32z'
      
    ]
  };

  

  
  

  var faCodeCommit = {
    prefix: 'fasr',
    iconName: 'code-commit',
    icon: [
      640,
      512,
      [],
      'f386',
      
      'M224 160l0 192 192 0 0-192-192 0zm-48-48l48 0 192 0 48 0 0 48 0 72 152 0 24 0 0 48-24 0-152 0 0 72 0 48-48 0-192 0-48 0 0-48 0-72L24 280 0 280l0-48 24 0 152 0 0-72 0-48z'
      
    ]
  };

  

  
  

  var faPercent = {
    prefix: 'fasr',
    iconName: 'percent',
    icon: [
      384,
      512,
      [62101,62785,"percentage"],
      '25',
      
      'M369 113l17-17L352 62.1 335 79 15 399l-17 17L32 449.9l17-17L369 113zM16 80l0 96 96 0 0-96L16 80zM272 336l0 96 96 0 0-96-96 0z'
      
    ]
  };

  
    var faPercentage = faPercent;
  

  
  

  var faY = {
    prefix: 'fasr',
    iconName: 'y',
    icon: [
      384,
      512,
      [121],
      '59',
      
      'M1.2 32L168 295l0 161 0 24 48 0 0-24 0-161L382.9 32 326 32 192 243.2 58 32 1.2 32z'
      
    ]
  };

  

  
  

  var faB = {
    prefix: 'fasr',
    iconName: 'b',
    icon: [
      320,
      512,
      [98],
      '42',
      
      'M24 32L0 32 0 56 0 232l0 24 0 24L0 456l0 24 24 0 172 0c68.5 0 124-55.5 124-124c0-48.2-27.5-90-67.8-110.5c22.1-21.8 35.8-52 35.8-85.5l0-8c0-66.3-53.7-120-120-120L24 32zM168 232L48 232 48 80l120 0c39.8 0 72 32.2 72 72l0 8c0 39.8-32.2 72-72 72zM48 280l120 0 24 0 4 0c42 0 76 34 76 76s-34 76-76 76L48 432l0-152z'
      
    ]
  };

  

  
  

  var faN = {
    prefix: 'fasr',
    iconName: 'n',
    icon: [
      384,
      512,
      [110],
      '4e',
      
      'M0 56L0 32l35.2 0 7.2 8.6L336 390.1 336 56l0-24 48 0 0 24 0 400 0 24-35.2 0-7.2-8.6L48 121.9 48 456l0 24L0 480l0-24L0 56z'
      
    ]
  };

  

  
  

  var faS = {
    prefix: 'fasr',
    iconName: 's',
    icon: [
      320,
      512,
      [115],
      '53',
      
      'M91.2 90.6c-24 10.1-37.9 26.2-41.8 48c-2.8 16.1-1 27.4 2.8 35.7c3.8 8.5 10.6 16.1 21.1 23.3c22.1 15.1 54.9 24.6 93.2 35.3c.8 .2 1.6 .4 2.4 .7c35.3 9.9 75.6 21.2 104.9 41.2c15.6 10.6 29.3 24.5 37.7 43.1c8.5 18.7 10.6 40 6.4 63.9c-7.2 40.8-34.4 68.8-70.5 83.9c-35.3 14.8-79.6 17.8-125.7 10.7l-.1 0c-24.5-3.9-64.3-17.2-90.9-26.2c-5.3-1.8-10-3.4-14-4.7L-6.3 438 8.6 392.4l22.8 7.4c4.9 1.6 10.5 3.5 16.3 5.4c26.9 9 61.2 20.4 81.3 23.6c40.4 6.2 75.1 2.9 99.8-7.5c24-10.1 37.9-26.2 41.8-48c2.8-16.1 1-27.4-2.8-35.7c-3.8-8.5-10.6-16.1-21.1-23.3c-22.1-15.1-54.9-24.6-93.2-35.3l-2.4-.7c-35.3-9.9-75.6-21.2-104.9-41.2c-15.6-10.6-29.3-24.5-37.7-43.1c-8.5-18.7-10.6-40-6.4-63.9l23.6 4.2L2.1 130.3C9.3 89.5 36.5 61.5 72.6 46.4c35.3-14.8 79.6-17.8 125.7-10.7c13.7 2.1 55.1 9.9 69.7 13.8l23.2 6.1-12.1 46.4-23.2-6.1c-12.4-3.2-52-10.8-64.9-12.8l3.6-23.7L191 83.1c-40.4-6.2-75.2-2.9-99.9 7.5z'
      
    ]
  };

  

  
  

  var faU = {
    prefix: 'fasr',
    iconName: 'u',
    icon: [
      384,
      512,
      [117],
      '55',
      
      'M48 32l0 24 0 232c0 79.5 64.5 144 144 144s144-64.5 144-144l0-232 0-24 48 0 0 24 0 232c0 106-86 192-192 192S0 394 0 288L0 56 0 32l48 0z'
      
    ]
  };

  

  
  

  var faArrowTurnDownLeft = {
    prefix: 'fasr',
    iconName: 'arrow-turn-down-left',
    icon: [
      512,
      512,
      [],
      'e2e1',
      
      'M464 56l0-24 48 0 0 24 0 232 0 24-24 0L93.1 312l79 79 17 17-33.9 33.9-17-17L18.2 305l-17-17 17-17 120-120 17-17L189.1 168l-17 17-79 79L464 264l0-208z'
      
    ]
  };

  

  
  

  var faO = {
    prefix: 'fasr',
    iconName: 'o',
    icon: [
      448,
      512,
      [111],
      '4f',
      
      'M224 80a176 176 0 1 0 0 352 176 176 0 1 0 0-352zM448 256A224 224 0 1 1 0 256a224 224 0 1 1 448 0z'
      
    ]
  };

  

  
  

  var faJ = {
    prefix: 'fasr',
    iconName: 'j',
    icon: [
      320,
      512,
      [106],
      '4a',
      
      'M320 32l0 24 0 264c0 88.4-71.6 160-160 160S0 408.4 0 320l0-40 0-24 48 0 0 24 0 40c0 61.9 50.1 112 112 112s112-50.1 112-112l0-264 0-24 48 0z'
      
    ]
  };

  

  
  

  var faCalendarXmark = {
    prefix: 'fasr',
    iconName: 'calendar-xmark',
    icon: [
      448,
      512,
      ["calendar-times"],
      'f273',
      
      'M152 0l0 24 0 40 144 0 0-40 0-24 48 0 0 24 0 40 104 0 0 80 0 48 0 272 0 48-48 0L48 512 0 512l0-48L0 192l0-48L0 64l104 0 0-40 0-24 48 0zM400 192L48 192l0 272 352 0 0-272zm-95 89l-47 47 47 47 17 17L288 425.9l-17-17-47-47-47 47-17 17L126.1 392l17-17 47-47-47-47-17-17L160 230.1l17 17 47 47 47-47 17-17L321.9 264l-17 17z'
      
    ]
  };

  
    var faCalendarTimes = faCalendarXmark;
  

  
  

  var faArrowRotateRight = {
    prefix: 'fasr',
    iconName: 'arrow-rotate-right',
    icon: [
      512,
      512,
      [8635,"arrow-right-rotate","arrow-rotate-forward","redo"],
      'f01e',
      
      'M472 224l24 0 0-24 0-144 0-24-48 0 0 24 0 80.1-20-23.5C387 63.4 325.1 32 256 32C132.3 32 32 132.3 32 256s100.3 224 224 224c50.4 0 97-16.7 134.4-44.8l-28.8-38.4C332.2 418.9 295.7 432 256 432c-97.2 0-176-78.8-176-176s78.8-176 176-176c54.3 0 102.9 24.6 135.2 63.4l.1 .2s0 0 0 0L418.9 176 328 176l-24 0 0 48 24 0 144 0z'
      
    ]
  };

  
    var faArrowRightRotate = faArrowRotateRight;
  
    var faArrowRotateForward = faArrowRotateRight;
  
    var faRedo = faArrowRotateRight;
  

  
  

  var faCircleEllipsisVertical = {
    prefix: 'fasr',
    iconName: 'circle-ellipsis-vertical',
    icon: [
      512,
      512,
      [],
      'e10b',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm224 64l64 0 0 64-64 0 0-64zm0-192l64 0 0 64-64 0 0-64zm0 160l0-64 64 0 0 64-64 0z'
      
    ]
  };

  

  
  

  var faR = {
    prefix: 'fasr',
    iconName: 'r',
    icon: [
      320,
      512,
      [114],
      '52',
      
      'M24 32L0 32 0 56 0 280 0 456l0 24 48 0 0-24 0-152 109.6 0L263.6 480l56 0L211.9 301.1C273.6 288.3 320 233.5 320 168c0-75.1-60.9-136-136-136L24 32zM176 256L48 256 48 80l136 0c48.6 0 88 39.4 88 88s-39.4 88-88 88l-8 0z'
      
    ]
  };

  

  
  

  var faH = {
    prefix: 'fasr',
    iconName: 'h',
    icon: [
      384,
      512,
      [104],
      '48',
      
      'M336 256l0 200 0 24 48 0 0-24 0-232 0-168 0-24-48 0 0 24 0 152L48 208 48 56l0-24L0 32 0 56 0 456l0 24 48 0 0-24 0-200 288 0z'
      
    ]
  };

  

  
  

  var faF = {
    prefix: 'fasr',
    iconName: 'f',
    icon: [
      320,
      512,
      [102],
      '46',
      
      'M24 32L0 32 0 56 0 248 0 456l0 24 48 0 0-24 0-184 184 0 24 0 0-48-24 0L48 224 48 80l248 0 24 0 0-48-24 0L24 32z'
      
    ]
  };

  

  
  

  var faArrowUpRightFromSquare = {
    prefix: 'fasr',
    iconName: 'arrow-up-right-from-square',
    icon: [
      512,
      512,
      ["external-link"],
      'f08e',
      
      'M328 0L304 0l0 48 24 0 102.1 0L207 271l-17 17L224 321.9l17-17 223-223L464 184l0 24 48 0 0-24 0-160 0-24L488 0 328 0zM24 32L0 32 0 56 0 488l0 24 24 0 432 0 24 0 0-24 0-176 0-24-48 0 0 24 0 152L48 464 48 80l152 0 24 0 0-48-24 0L24 32z'
      
    ]
  };

  
    var faExternalLink = faArrowUpRightFromSquare;
  

  
  

  var faP = {
    prefix: 'fasr',
    iconName: 'p',
    icon: [
      320,
      512,
      [112],
      '50',
      
      'M48 288l120 0c57.4 0 104-46.6 104-104s-46.6-104-104-104L48 80l0 208zm0 48l0 120 0 24L0 480l0-24L0 312 0 56 0 32l48 0 120 0c83.9 0 152 68.1 152 152s-68.1 152-152 152L48 336z'
      
    ]
  };

  

  
  

  var faA = {
    prefix: 'fasr',
    iconName: 'a',
    icon: [
      384,
      512,
      [97],
      '41',
      
      'M175.5 32l33 0 5.9 15.4L380.7 480l-51.4 0-36.9-96L91.6 384 54.7 480 3.3 480 169.6 47.4 175.5 32zM192 122.9L110.1 336l163.9 0L192 122.9z'
      
    ]
  };

  

  
  

  var faZ = {
    prefix: 'fasr',
    iconName: 'z',
    icon: [
      384,
      512,
      [122],
      '5a',
      
      'M384 32l-24 0L24 32 0 32 0 80l24 0 284.5 0L5.6 440.6 0 447.3 0 480l24 0 336 0 24 0 0-48-24 0L75.5 432 378.4 71.4l5.6-6.7L384 32z'
      
    ]
  };

  

  
  

  var faL = {
    prefix: 'fasr',
    iconName: 'l',
    icon: [
      320,
      512,
      [108],
      '4c',
      
      'M80 32l0 24 0 376 216 0 24 0 0 48-24 0L56 480l-24 0 0-24L32 56l0-24 48 0z'
      
    ]
  };

  

  
  

  var faCalendarStar = {
    prefix: 'fasr',
    iconName: 'calendar-star',
    icon: [
      448,
      512,
      [],
      'f736',
      
      'M152 0l0 24 0 40 144 0 0-40 0-24 48 0 0 24 0 40 104 0 0 80 0 48 0 272 0 48-48 0L48 512 0 512l0-48L0 192l0-48L0 64l104 0 0-40 0-24 48 0zM400 192L48 192l0 272 352 0 0-272zM253.6 295.2l76.9 6.2-58.6 50.2 17.9 75L224 386.4l-65.8 40.2 17.9-75-58.6-50.2 76.9-6.2L224 224l29.6 71.2z'
      
    ]
  };

  

  
  

  var faC = {
    prefix: 'fasr',
    iconName: 'c',
    icon: [
      384,
      512,
      [99],
      '43',
      
      'M343.5 131.7C275.8 63 166 63 98.3 131.7s-67.7 180 0 248.7s177.5 68.7 245.2 0l33.7 34.2c-86.3 87.5-226.3 87.5-312.6 0s-86.3-229.5 0-317S290.9 10 377.2 97.5l-33.7 34.2z'
      
    ]
  };

  

  
  

  var faE = {
    prefix: 'fasr',
    iconName: 'e',
    icon: [
      320,
      512,
      [101],
      '45',
      
      'M24 32L0 32 0 56 0 256 0 456l0 24 24 0 272 0 24 0 0-48-24 0L48 432l0-160 184 0 24 0 0-48-24 0L48 224 48 80l248 0 24 0 0-48-24 0L24 32z'
      
    ]
  };

  

  
  

  var faG = {
    prefix: 'fasr',
    iconName: 'g',
    icon: [
      448,
      512,
      [103],
      '47',
      
      'M224 80C126.8 80 48 158.8 48 256s78.8 176 176 176c89.1 0 162.7-66.2 174.4-152l-149 0-24 0 0-48 24 0L424 232l24 0 0 24c0 123.7-100.3 224-224 224S0 379.7 0 256S100.3 32 224 32c66.7 0 126.7 29.2 167.7 75.5l-35.9 31.8C323.5 102.9 276.4 80 224 80z'
      
    ]
  };

  

  
  

  var faQ = {
    prefix: 'fasr',
    iconName: 'q',
    icon: [
      448,
      512,
      [113],
      '51',
      
      'M48 256c0 97.2 78.8 176 176 176c31 0 60.1-8 85.4-22.1L194.9 256l59.8 0 93 125.1C380 349.2 400 304.9 400 256c0-97.2-78.8-176-176-176S48 158.8 48 256zM338.2 448.7C304.8 468.6 265.7 480 224 480C100.3 480 0 379.7 0 256S100.3 32 224 32s224 100.3 224 224c0 64.7-27.5 123.1-71.4 163.9L445.1 512l-59.8 0-47-63.3z'
      
    ]
  };

  

  
  

  var faSparkles = {
    prefix: 'fasr',
    iconName: 'sparkles',
    icon: [
      512,
      512,
      [10024],
      'f890',
      
      'M384 64L320 96l64 32 32 64 32-64 64-32L448 64 416 0 384 64zM256 320l74.3-37.2L384 256l-53.7-26.8L256 192l-37.2-74.3L192 64l-26.8 53.7L128 192 53.7 229.2 0 256l53.7 26.8L128 320l37.2 74.3L192 448l26.8-53.7L256 320zm-64 20.7l-21.1-42.1-7.2-14.3-14.3-7.2L107.3 256l42.1-21.1 14.3-7.2 7.2-14.3L192 171.3l21.1 42.1 7.2 14.3 14.3 7.2L276.7 256l-42.1 21.1-14.3 7.2-7.2 14.3L192 340.7zM416 320l-32 64-64 32 64 32 32 64 32-64 64-32-64-32-32-64z'
      
    ]
  };

  

  
  

  var faV = {
    prefix: 'fasr',
    iconName: 'v',
    icon: [
      384,
      512,
      [118],
      '56',
      
      'M329.3 32L192 389.1 54.7 32 3.3 32 169.6 464.6l5.9 15.4 33 0 5.9-15.4L380.7 32l-51.4 0z'
      
    ]
  };

  

  
  

  var faI = {
    prefix: 'fasr',
    iconName: 'i',
    icon: [
      320,
      512,
      [105],
      '49',
      
      'M24 32L0 32 0 80l24 0 112 0 0 352L24 432 0 432l0 48 24 0 272 0 24 0 0-48-24 0-112 0 0-352 112 0 24 0 0-48-24 0L160 32 24 32z'
      
    ]
  };

  

  
  

  var faCommand = {
    prefix: 'fasr',
    iconName: 'command',
    icon: [
      512,
      512,
      [],
      'e142',
      
      'M0 0L24 0 160 0l24 0 0 24 0 112 144 0 0-112 0-24 24 0L488 0l24 0 0 24 0 144 0 24-24 0-112 0 0 128 112 0 24 0 0 24 0 144 0 24-24 0-136 0-24 0 0-24 0-112-144 0 0 112 0 24-24 0L24 512 0 512l0-24L0 344l0-24 24 0 112 0 0-128L24 192 0 192l0-24L0 24 0 0zM136 144l0-8 0-88L48 48l0 96 88 0zm48 176l0 8 144 0 0-8 0-128 0-8-144 0 0 8 0 128zm-48 48l-88 0 0 96 88 0 0-88 0-8zm240 8l0 88 88 0 0-96-88 0 0 8zm0-232l88 0 0-96-88 0 0 88 0 8z'
      
    ]
  };

  

  
  

  var faChevronUp = {
    prefix: 'fasr',
    iconName: 'chevron-up',
    icon: [
      512,
      512,
      [],
      'f077',
      
      'M256 94.1l17 17L465 303l17 17L448 353.9l-17-17-175-175L81 337l-17 17L30.1 320l17-17L239 111l17-17z'
      
    ]
  };

  

  
  

  var faBars = {
    prefix: 'fasr',
    iconName: 'bars',
    icon: [
      448,
      512,
      ["navicon"],
      'f0c9',
      
      'M0 64l448 0 0 48L0 112 0 64zM0 224l448 0 0 48L0 272l0-48zM448 384l0 48L0 432l0-48 448 0z'
      
    ]
  };

  
    var faNavicon = faBars;
  

  
  

  var faW = {
    prefix: 'fasr',
    iconName: 'w',
    icon: [
      576,
      512,
      [119],
      '57',
      
      'M145.2 463.4L5.2 32l50.5 0L167.1 375.5 265 49.1 270.1 32l35.7 0L311 49.1l97.9 326.4L520.3 32l50.5 0-140 431.4L425.4 480l-35.3 0L385 462.9 288 139.5 191 462.9 185.9 480l-35.3 0-5.4-16.6z'
      
    ]
  };

  

  
  

  var faUp = {
    prefix: 'fasr',
    iconName: 'up',
    icon: [
      384,
      512,
      ["arrow-alt-up"],
      'f357',
      
      'M160 240l0 48 0 144 64 0 0-144 0-48 48 0 60.1 0L192 99.9 51.9 240l60.1 0 48 0zM48 288L0 288l0-48 0-16L158.1 65.9 192 32l33.9 33.9L384 224l0 16 0 48-48 0-16 0-48 0 0 48 0 96 0 48-48 0-64 0-48 0 0-48 0-96 0-48-48 0-16 0z'
      
    ]
  };

  
    var faArrowAltUp = faUp;
  

  
  

  var faClipboardList = {
    prefix: 'fasr',
    iconName: 'clipboard-list',
    icon: [
      384,
      512,
      [],
      'f46d',
      
      'M336 64l-32 0-33.6 0C263 27.5 230.7 0 192 0s-71 27.5-78.4 64L80 64 48 64 0 64l0 48L0 464l0 48 48 0 288 0 48 0 0-48 0-352 0-48-48 0zM80 112l0 48 112 0 112 0 0-48 32 0 0 352L48 464l0-352 32 0zm88-32a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM112 392a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm64-136l-16 0 0 32 16 0 96 0 16 0 0-32-16 0-96 0zm0 96l-16 0 0 32 16 0 96 0 16 0 0-32-16 0-96 0zm-64-56a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faK = {
    prefix: 'fasr',
    iconName: 'k',
    icon: [
      320,
      512,
      [107],
      '4b',
      
      'M48 265.2L256.8 32l64.4 0-5.4 6L156.3 216.2 319.9 480l-56.5 0L122.9 253.5 48 337.2 48 456l0 24L0 480l0-24L0 328 0 56 0 32l48 0 0 24 0 209.2z'
      
    ]
  };

  

  
  

  var faAnglesDown = {
    prefix: 'fasr',
    iconName: 'angles-down',
    icon: [
      448,
      512,
      ["angle-double-down"],
      'f103',
      
      'M241 273l-17 17-17-17L47 113l-17-17L64 62.1 81 79l143 143L367 79l17-17L417.9 96l-17 17L241 273zm0 192l-17 17-17-17L47 305l-17-17L64 254.1l17 17 143 143L367 271l17-17L417.9 288l-17 17L241 465z'
      
    ]
  };

  
    var faAngleDoubleDown = faAnglesDown;
  



export {

  faD,
  

  faX,
  

  faDollarSign,
  
  faDollar,
  
  faUsd,
  

  faM,
  

  faCalendar,
  

  faT,
  

  faCodeCommit,
  

  faPercent,
  
  faPercentage,
  

  faY,
  

  faB,
  

  faN,
  

  faS,
  

  faU,
  

  faArrowTurnDownLeft,
  

  faO,
  

  faJ,
  

  faCalendarXmark,
  
  faCalendarTimes,
  

  faArrowRotateRight,
  
  faArrowRightRotate,
  
  faArrowRotateForward,
  
  faRedo,
  

  faCircleEllipsisVertical,
  

  faR,
  

  faH,
  

  faF,
  

  faArrowUpRightFromSquare,
  
  faExternalLink,
  

  faP,
  

  faA,
  

  faZ,
  

  faL,
  

  faCalendarStar,
  

  faC,
  

  faE,
  

  faG,
  

  faQ,
  

  faSparkles,
  

  faV,
  

  faI,
  

  faCommand,
  

  faChevronUp,
  

  faBars,
  
  faNavicon,
  

  faW,
  

  faUp,
  
  faArrowAltUp,
  

  faClipboardList,
  

  faK,
  

  faAnglesDown,
  
  faAngleDoubleDown,
  

};
